import { referralOverviewCardId, referralOverviewLinkId } from "@/assets/googleTrackIds";
import { DashboardRoutes } from "@/router";
import { useAppSelector, useAppTranslation } from "@/utils";
import { PhRCopy } from "@payping/icons";
import { buildUrl } from "@payping/utilities-shared/url";
import { Button, Flex, Input, LegacyCard, Typography, message } from "@payping/web-components";
import copy from "copy-to-clipboard";
import { Link } from "react-router-dom";
import { URLS } from "@payping/utilities-shared/consts";

const ReferralCode = () => {
  const { t } = useAppTranslation();

  const { checksPercent, referralCode, isReferralActive } = useAppSelector((state) => ({
    checksPercent: state.user.checks?.percentComplete,
    referralCode: state.user?.referralCode,
    isReferralActive: state.user?.isReferralActive,
  }));

  const referralCodeUrl = isReferralActive ? buildUrl(URLS.PPNG_URL, "r", referralCode || "").toString() : undefined;
  const referralCodeUrlWithoutHttps = referralCodeUrl ? referralCodeUrl.replace("https://", "") : undefined;

  const handleCopyUrl = () => {
    if (!referralCodeUrl) return;
    const copied = copy(referralCodeUrl);
    if (copied) message.success({ content: t("messages.copied") });
  };

  if (!checksPercent || checksPercent < 60) return null;

  const activeReferralContent = (
    <Flex align="center" gap="middle">
      <Input
        placeholder={referralCodeUrlWithoutHttps}
        data-google-track={referralOverviewLinkId}
        value={referralCodeUrlWithoutHttps}
        className={"tw:text-left"}
        addonBefore={
          <PhRCopy
            width={14}
            onClick={() => {
              handleCopyUrl();
            }}
            data-google-track={referralOverviewLinkId}
          />
        }
      />
    </Flex>
  );

  const disableReferralContent = (
    <>
      <Typography.Text className="color--gray500">{t("overview.referralCode.startEarnContent")}</Typography.Text>
      <div>
        <Link to={DashboardRoutes.user.referral.url} data-google-track={referralOverviewCardId}>
          <Button className="w-auto" type="default">
            {t("overview.referralCode.ActivationEarn")}
          </Button>
        </Link>
      </div>
    </>
  );

  return (
    <LegacyCard.Ant
      className="w-100"
      cover={
        !isReferralActive && (
          <img
            alt={"referral"}
            style={{
              border: "1px solid #f0f0f0",
              borderBottom: "0",
            }}
            src={buildUrl(URLS.STORAGE_URL, "img/home/referralNew.svg").toString()}
          />
        )
      }
    >
      <LegacyCard.Meta
        title={
          <Typography.Text className="m-0">
            {t("overview.referralCode.title")}
            {" :"}
          </Typography.Text>
        }
        description={
          <Flex vertical gap="8px" justify="center">
            {isReferralActive ? activeReferralContent : disableReferralContent}
          </Flex>
        }
      />
    </LegacyCard.Ant>
  );
};

export default ReferralCode;
